var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle',{staticClass:"favourites-button",attrs:{"on":_vm.is_on,"data":_vm.data,"url":_vm.url},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var on = ref.on;
var setOff = ref.setOff;
var setOn = ref.setOn;
return [_c('button',{ref:"button",class:{
        'is-active': on,
        'is-loading': _vm.loading,
      },on:{"click":function($event){return _vm.click(on, setOn, setOff)}}},[_vm._t("default"),_c('transition',{attrs:{"name":"shrink","mode":"out-in"}},[(on)?_vm._t("on"):_vm._e()],2),_c('transition',{attrs:{"name":"shrink","mode":"out-in"}},[(!on)?_vm._t("off"):_vm._e()],2),(_vm.$slots.label)?_c('span',{staticClass:"pl-3"},[_vm._t("label")],2):_vm._e()],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }